export interface ChatAgent {
  name: string
  avatar: string
}

export const CHAT_AGENTS: ChatAgent[] = [
  { name: 'Aminata', avatar: '/public/assets/tchat/600w/avatar.jpg' },
  { name: 'Moussa',  avatar: '/public/assets/tchat/600w/avatar2.jpg' },
  { name: 'Fatou',   avatar: '/public/assets/tchat/600w/avatar3.jpg' },
  { name: 'Ibrahima',avatar: '/public/assets/tchat/600w/avatar4.jpg' },
  { name: 'Aïcha',   avatar: '/public/assets/tchat/600w/avatar5.jpg' },
  { name: 'Omar',    avatar: '/public/assets/tchat/600w/avatar6.jpg' },
]
